import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { Patient } from '../../../core/models/patient.model';
import { Prescriber } from '../../../core/models/prescriber.model';
import { OutboundFax } from '../../../core/models/outbound-fax.model';
import { PagedOutboundFaxesResult, PatientService } from '../../../core/services/patient.service';
import { OutboundFaxStatus } from '../../../core/enums/outbound-fax-status.enum';
import { DatePipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { OfficeFaxComponent } from '../../../shared/components/office-fax/office-fax.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

const visibleStatuses = [OutboundFaxStatus.sent, OutboundFaxStatus.failed];

@Component({
  selector: 'app-inbound-fax-select-outbound-fax',
  templateUrl: './inbound-fax-select-outbound-fax.component.html',
  styleUrls: ['./inbound-fax-select-outbound-fax.component.scss'],
  imports: [MatProgressSpinner,
    FormsModule,
    OfficeFaxComponent,
    PrescriberNameComponent,
    DatePipe,
    BlankValueDashPipe]
})
export class InboundFaxSelectOutboundFaxComponent implements OnChanges {
  private patientService = inject(PatientService);

  outboundFaxes: OutboundFax[] = new Array<OutboundFax>();
  outboundFaxStatuses = OutboundFaxStatus;

  loading = false;
  selectedOutboundFaxId = null;

  @Input() selectedPatient: Patient;
  @Input() selectedPrescriber: Prescriber;
  @Input() selectedOutboundFax: OutboundFax;

  @Output() public selectionChange = new EventEmitter<OutboundFax>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedOutboundFax) {
      this.selectedOutboundFaxId = this.selectedOutboundFax?.id ?? null;
    }

    if (changes.selectedPatient || changes.selectedPrescriber) {
      if (this.selectedPatient && this.selectedPrescriber) {
        this.loadOutboundFaxes();
      } else {
        this.outboundFaxes = new Array<OutboundFax>();
      }
    }
  }

  onOutboundFaxChanges(outboundFax: OutboundFax) {
    this.selectionChange.next(outboundFax);
  }

  onClearClick($event: MouseEvent) {
    $event.preventDefault();
    this.selectionChange.next(null);
  }

  private loadOutboundFaxes() {
    this.loading = true;
    this.patientService
      .getOutboundFaxes(this.selectedPatient.id, this.selectedPrescriber?.npi ?? null, visibleStatuses,
        { page: 1, pageSize: 'all' })
      .subscribe((result: PagedOutboundFaxesResult) => {
        this.outboundFaxes = result.records || new Array<OutboundFax>();
        this.loading = false;
      });
  }
}
